import React, { useState } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { BaseDropdown } from "@components/library/UI/BaseDropdown";

import { ReactComponent as ArrowIcon } from "@assets/images/icons/arrow-down-icon.svg";

import "./PerformanceChart.sass";

const data = [
  { date: "06/17", value: 1.2 },
  { date: "06/24", value: 1.8 },
  { date: "07/08", value: 2.6 },
  { date: "07/22", value: 2.98 },
  { date: "08/06", value: 2.2 },
  { date: "08/20", value: 2.8 },
  { date: "09/04", value: 2.5 },
  { date: "09/18", value: 3.24 },
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="performance-chart__tooltip">
        <div className="performance-chart__tooltip-item">
          <span className="performance-chart__tooltip-label">Time</span>
          <span className="performance-chart__tooltip-value">Jul 22</span>{" "}
        </div>
        <div className="performance-chart__tooltip-item">
          <span className="performance-chart__tooltip-label">Cap (USD)</span>
          <span className="performance-chart__tooltip-value">
            {payload[0].value}T
          </span>
        </div>
      </div>
    );
  }
  return null;
};

export const PerformanceChart = () => {
  const [activeTab, setActiveTab] = useState("ROI");
  const [period, setPeriod] = useState("30 Days");

  return (
    <div className="performance-chart">
      {/* 1. HEADER (Tabs and Dropdown) */}
      <div className="performance-chart__header">
        <div className="performance-chart__tabs">
          <button
            className={`performance-chart__tab ${
              activeTab === "ROI" ? "performance-chart__tab--active" : ""
            }`}
            onClick={() => setActiveTab("ROI")}
          >
            ROI
          </button>
          <button
            className={`performance-chart__tab ${
              activeTab === "PNL" ? "performance-chart__tab--active" : ""
            }`}
            onClick={() => setActiveTab("PNL")}
          >
            PNL
          </button>
        </div>

        <div className="performance-chart__controls">
          <BaseDropdown
            trigger={
              <button className="performance-chart__dropdown-btn">
                {period} <ArrowIcon />
              </button>
            }
          >
            {({ closeDropdown }) => (
              <div className="performance-chart__dropdown-menu">
                {["7 Days", "30 Days", "90 Days"].map((opt) => (
                  <div
                    key={opt}
                    className="performance-chart__dropdown-item"
                    onClick={() => {
                      setPeriod(opt);
                      closeDropdown();
                    }}
                  >
                    {opt}
                  </div>
                ))}
              </div>
            )}
          </BaseDropdown>
        </div>
      </div>

      <div className="performance-chart__high-low">
        <p>Highest: $3.24T</p>
        <p>Lowest: $0.9T</p>
      </div>

      {/* 2. THE GRAPH */}
      <div className="performance-chart__graph-container">
        <ResponsiveContainer width="100%" height={290}>
          <AreaChart
            data={data}
            margin={{ top: 10, right: 0, left: -20, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#23C381" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#23C381" stopOpacity={0} />
              </linearGradient>
            </defs>

            <CartesianGrid
              strokeDasharray="3 3"
              stroke="#2E2E2E"
              vertical={true}
              horizontal={true}
            />

            <XAxis
              dataKey="date"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#888888", fontSize: 12, dy: 10 }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#888888", fontSize: 12 }}
              tickFormatter={(val) => `${val}T`}
            />

            <Tooltip
              content={<CustomTooltip />}
              cursor={{
                stroke: "#4B4B4B",
                strokeWidth: 1,
                strokeDasharray: "3 3",
              }}
            />

            <Area
              type="monotone"
              dataKey="value"
              stroke="#23C381"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorValue)"
              activeDot={{
                r: 6,
                fill: "#23C381",
                stroke: "#181818",
                strokeWidth: 3,
              }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
